import React from 'react';
import { ListGroup, Tab } from "react-bootstrap";
import moment from "moment";
import mdParser from "../utils/parser"
import HtmlParser from './html_parser';

const getWebTab = (propuesta) => {
  const { articulo } = propuesta

  return <Tab
  eventKey="web"
  title={
    <>
      <i className="fab fa-html5 is-selected"></i> Vista Web
    </>
  }
>
  <div className="row" style={{ textAlign: "left" }}>
    {articulo && (
      <div className="col-sm">
        <br />
        <br />
        <h3>Versión Actual:</h3>
        <br />
        <h5>Metadatos:</h5>
        {/* <div style={{whiteSpace: 'pre-line'}}>{YAML.stringify(oldDoc.metadata)}</div> */}
        {['titulo', 'etiquetas', 'relacionados', 'creado', 'modificado']
          .sort()
          .map((key) => {
            return (
              <ListGroup.Item key={key}>
                <span
                  style={{
                    fontWeight: "bold",
                    textTransform: "capitalize",
                  }}
                >
                  {key}:{" "}
                </span>
                {Array.isArray(articulo[key])
                  ? articulo[key].join(", ")
                  : key === "creado" || key === "modificado"
                  ? moment(articulo[key]).format(
                      "LLL"
                    )
                  : articulo[key] || ''}
              </ListGroup.Item>
            );
          })}
        <br />
        <h5>Contenido:</h5>
        <hr />
        <HtmlParser fontSize={90} html={mdParser.parse(articulo.contenido)} />
      </div>
    )}
    {propuesta && (
      <div className="col-sm">
        <br />
        <br />
        <h3>Propuesto:</h3>
        <br />
        <h5>Metadatos:</h5>
        {['titulo', 'etiquetas', 'relacionados', 'creado', 'fecha']
          .sort()
          .map((key) => {
            return (
              <ListGroup.Item key={key}>
                <span
                  style={{
                    fontWeight: "bold",
                    textTransform: "capitalize",
                  }}
                >
                  {key === 'fecha' ? 'Modificado' : key}:{" "}
                </span>
                {Array.isArray(propuesta[key])
                  ? propuesta[key].join(", ")
                  : key === "fecha" || key === "creado"
                  ? moment(propuesta[key]).format("LLL")
                  : propuesta[key] || ''}
              </ListGroup.Item>
            );
          })}
        <br />
        <h5>Contenido:</h5>
        <hr />
        <HtmlParser fontSize={90} html={propuesta.html} />
      </div>
    )}
  </div>
</Tab>
}

export default getWebTab